/*
 * FRK Voice Search: lexicon and clean-up rules (no DOM, so it can be tested in Node).
 * Turns what the microphone heard into the words the shop search matches best:
 *   "I'm looking for a twenty square metre roof sell kit" -> "20m² RoofCell kit"
 * Order: your own corrections (Theme settings > Search) -> brand and product phrases -> spoken numbers
 *        -> units -> product codes (A200, B230...) -> phonetic fix against the catalogue vocabulary.
 * Add to FRK_VOICE_PHRASES for built-in fixes, or use Theme settings > Search > Voice search corrections.
 */
(function (root, factory) {
  if (typeof module === 'object' && module.exports) module.exports = factory();
  else root.FRKVoice = factory();
})(typeof self !== 'undefined' ? self : this, function () {
  'use strict';

  // Product codes that exist in the catalogue (letter + digits in product titles)
  var CODES = ['A170', 'A200', 'A250', 'B230', 'B260', 'B300', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C100', 'C150', 'D260', 'D300', 'E280', 'F300', 'F600', 'F900', 'G4', 'G180', 'P40', 'SC8'];

  // Words that appear in product titles (the phonetic fix only ever corrects TO these)
  var VOCAB = ('acegrip acetone adhesive aluminium angle anthracite application balcony bandage basecoat black brush bucket calibrated catalyst chopped clear closure clout collar complete core corner coverall cromar csm cup cure damp dark dip dispenser double drip drum duty edge expansion external extension fascia fibreglass fillet fire flashing flat frame gloves grade graphite grey grit grp gully gutter hand hardener head heavy heavyweight industrial internal iso joint kit large latex lead mat medium mekp metre metres mini mixing nails nylon outlet pack paddle paper parapet paste pigment pile pipe plastic pole polyurethane pond premium primer pro push rainwater raised rated refill resin revive ridge roll roller roof roofcell roofer roofing rubber sander scissors sealant sealer shears simulated smart smooth standard stirrer strand stronghold summer super surface syringe system tissue tool topcoat trade trim universal velour wall winter xlarge yellow').split(' ');

  // Ordinary words that must never be "corrected" by the phonetic step
  var KEEP = ('about above after again also another any are around back been before best between both brand buy can cheap colour colours color cost does done each easy enough even every find fit for free from get give good have help here how into just keep kind know large like long look looking make many more most much must need next not now offer only other over please price prices quick quite really right same send shop show size sizes small some something sort still such sure take than thanks that the their them then there these they thing this those through too under until used want warm was water well were what when where which while whole will with without work would year your you').split(' ');

  // Words that sound like something the shop sells (heard -> what to search for). Case-insensitive, whole words.
  var FRK_VOICE_PHRASES = [
    // brands
    [/\b(?:curate|cure\s*eat|cure\s*at|cureit|cure\s*it|kure\s*it|cure\s*8|queue\s*it)\b/gi, 'Cure It'],
    [/\bCure It\s+(?:1|one|won|juan)\b/gi, 'Cure It One'],
    [/\broof\s*(?:cell|cells|sell|sale|self|sel)\b/gi, 'RoofCell'],
    [/\bstrong\s*hold\b/gi, 'Stronghold'],
    [/\btrade\s*(?:great|grades|graded|grates?)\b/gi, 'Trade Grade'],
    [/\bpro\s*(?:g\s*r\s*p|jeep|grip|gee\s*are\s*pee)\b/gi, 'PRO GRP'],
    [/\b(?:chromar|crow\s*mar|cro\s*mar|cromer|cromah)\b/gi, 'Cromar'],
    [/\bace\s*grip\b/gi, 'AceGrip'],
    [/\bflexi\s*tech?\b/gi, 'Flexitec'],
    [/\bres\s*tech?\b/gi, 'Res-Tec'],
    // materials
    [/\bg\.?\s*r\.?\s*p\.?(?=\s|$)/gi, 'GRP'],
    [/\bgee\s*are\s*pee\b/gi, 'GRP'],
    [/\bjeep(?=\s+(?:roof|kit|roofing|resin))/gi, 'GRP'],
    [/\b(?:fiber\s*glass|fibre\s*glass|glass\s*fib(?:re|er)s?)\b/gi, 'fibreglass'],
    [/\btop\s*coats?\b/gi, 'topcoat'],
    [/\bbase\s*coats?\b/gi, 'basecoat'],
    [/\b(?:raisin|raisins|risen|rezin|rezzin|resign)\b/gi, 'resin'],
    [/\b(?:catalist|cattle\s*list|cat\s*a\s*list|catalyse)\b/gi, 'catalyst'],
    [/\bharder(?:ner)?\b/gi, 'hardener'],
    [/\bm\s*e\s*k\s*p\b|\bmek\s*p\b|\bmeck\s*p\b/gi, 'MEKP'],
    [/\bc\s*s\s*m\b/gi, 'CSM'],
    [/\bchop(?:ped|per)?\s*strand\s*(?:mat|matt|matting)\b/gi, 'chopped strand mat'],
    [/\b(?:matt|matting)\b/gi, 'mat'],
    // trims and fittings
    [/\b(?:fashion|fashia|fasha|facia|fassia|fashier)\b/gi, 'fascia'],
    [/\bfacial(?=\s+(?:trim|board|drip))/gi, 'fascia'],
    [/\bdry\s*trim\b/gi, 'drip trim'],
    [/\bflushing(?:s)?\b/gi, 'flashing'],
    [/\bfill\s*it(?=\s+(?:trim|corner))/gi, 'fillet'],
    [/\bcloud\s*nails?\b/gi, 'clout nails'],
    [/\b(?:velor|valor|velure)\b/gi, 'velour'],
    [/\broof(?:ing)?\s*(?:kid|kids|kick|kicks)\b/gi, 'roofing kit'],
    [/\bheavy[\s-]*duty\b/gi, 'heavy duty'],
    [/\bfire[\s-]*rated\b/gi, 'fire rated'],
    // RAL colour numbers: "rail seventy sixteen"
    [/\b(?:rail|real|rowl|rawl|raul|r\s*a\s*l)(?=\s+(?:\d|zero|oh|one|two|three|four|five|six|seven|eight|nine|ten|eleven|twelve|thirteen|fourteen|fifteen|sixteen|seventeen|eighteen|nineteen|twenty|thirty|forty|fifty|sixty|seventy|eighty|ninety)\b)/gi, 'RAL'],
    // colours
    [/\bgray\b/gi, 'grey'],
    [/\b(?:anthra\s*site|anthrasite|anthracyte|and\s*gracite|ant\s*racite)\b/gi, 'anthracite'],
    [/\bgraphight\b/gi, 'graphite'],
    // measures
    [/\bmeters?\b/gi, function (m) { return /s$/i.test(m) ? 'metres' : 'metre'; }],
    [/\bkilos?\b|\bkilogrammes?\b/gi, 'kilogram']
  ];

  // ---- spoken numbers ----------------------------------------------------------------------------------------
  var ONES = { zero: 0, oh: 0, one: 1, two: 2, three: 3, four: 4, five: 5, six: 6, seven: 7, eight: 8, nine: 9 };
  var TEENS = { ten: 10, eleven: 11, twelve: 12, thirteen: 13, fourteen: 14, fifteen: 15, sixteen: 16, seventeen: 17, eighteen: 18, nineteen: 19 };
  var TENS = { twenty: 20, thirty: 30, forty: 40, fifty: 50, sixty: 60, seventy: 70, eighty: 80, ninety: 90 };
  // "oh" only counts as a number inside a run that already has a clear number word ("seven oh one six")
  var WEAK = { oh: 1 };

  function clean(w) { return w.toLowerCase().replace(/[^a-z-]/g, ''); }
  function kind(w) {
    var c = clean(w);
    if (c.indexOf('-') > 0) { var p = c.split('-'); if (TENS[p[0]] && ONES[p[1]] !== undefined && !WEAK[p[1]]) return 'tensones'; }
    if (WEAK[c]) return 'weak';
    if (ONES[c] !== undefined) return 'one';
    if (TEENS[c] !== undefined) return 'teen';
    if (TENS[c] !== undefined) return 'ten';
    if (c === 'hundred') return 'hundred';
    if (c === 'thousand') return 'thousand';
    if (c === 'point') return 'point';
    if (c === 'and') return 'and';
    return '';
  }
  function val(w) {
    var c = clean(w);
    if (c.indexOf('-') > 0) { var p = c.split('-'); return TENS[p[0]] + ONES[p[1]]; }
    return ONES[c] !== undefined ? ONES[c] : (TEENS[c] !== undefined ? TEENS[c] : TENS[c]);
  }

  // Standard reading: "twenty five" 25, "four hundred and fifty" 450, "seven thousand and sixteen" 7016, "one point five" 1.5
  function standard(run) {
    var total = 0, cur = 0, dec = null, i;
    for (i = 0; i < run.length; i++) {
      var k = kind(run[i]);
      if (dec !== null) { if (k === 'one' || k === 'weak') dec += String(val(run[i])); continue; }
      if (k === 'point') { dec = ''; continue; }
      if (k === 'and') continue;
      if (k === 'hundred') { cur = (cur || 1) * 100; continue; }
      if (k === 'thousand') { total += (cur || 1) * 1000; cur = 0; continue; }
      cur += val(run[i]);
    }
    var n = String(total + cur);
    return dec ? n + '.' + dec : n;
  }
  // Digit-by-digit reading (codes and RAL numbers): "two three zero" 230, "two thirty" 230, "seventy sixteen" 7016
  function digits(run) {
    var out = '', i = 0;
    while (i < run.length) {
      var k = kind(run[i]);
      if (k === 'and') { i++; continue; }
      if (k === 'one' || k === 'weak') {
        if (run[i + 1] && kind(run[i + 1]) === 'hundred') {
          out += String(val(run[i])); i += 2; out += '00';
          if (run[i] && kind(run[i]) === 'and') i++;
          if (run[i] && (kind(run[i]) === 'ten' || kind(run[i]) === 'teen' || kind(run[i]) === 'tensones')) { out = out.slice(0, -2) + String(val(run[i])); i++; }
          continue;
        }
        out += String(val(run[i])); i++; continue;
      }
      if (k === 'teen' || k === 'tensones') { out += String(val(run[i])); i++; continue; }
      if (k === 'ten') {
        var v = val(run[i]);
        if (run[i + 1] && kind(run[i + 1]) === 'one' && val(run[i + 1]) > 0) { v += val(run[i + 1]); i++; }
        out += String(v); i++; continue;
      }
      if (k === 'hundred') { out += '00'; i++; continue; }
      i++;
    }
    return out;
  }

  function numberWords(text) {
    var words = text.split(/\s+/), out = [], i = 0;
    while (i < words.length) {
      var w = words[i], k = kind(w);
      // protect the brand name "Cure It One"
      if (k === 'one' && /^one$/i.test(clean(w)) && i >= 2 && /^it$/i.test(words[i - 1]) && /^cure$/i.test(words[i - 2])) { out.push(w); i++; continue; }
      if (!k || k === 'and' || k === 'point' || k === 'weak') { out.push(w); i++; continue; }
      // gather a run of number words
      var j = i, run = [], hasClear = false;
      while (j < words.length) {
        var kj = kind(words[j]);
        if (!kj) break;
        if (kj === 'and' && !(run.length && kind(words[j + 1] || '') && kind(words[j + 1]) !== 'and')) break;
        if (kj === 'point' && !(run.length && kind(words[j + 1] || '') === 'one')) break;
        if (kj === 'weak' && !run.length) break;
        if (kj !== 'weak' && kj !== 'and') hasClear = true;
        run.push(words[j]); j++;
      }
      var prev = (out[out.length - 1] || '').toLowerCase();
      var convert;
      if (!hasClear) { out.push(w); i++; continue; }
      if (prev === 'ral') convert = run.some(function (x) { return kind(x) === 'thousand'; }) ? standard(run) : digits(run);
      else if (run.length >= 2 && run.every(function (x) { var c = kind(x); return c === 'one' || c === 'weak'; })) convert = digits(run);   // "two three zero"
      else convert = standard(run);
      out.push(convert); i = j;
    }
    return out.join(' ');
  }

  // ---- units -------------------------------------------------------------------------------------------------
  function units(t) {
    return t
      .replace(/(\d+(?:\.\d+)?)\s*(?:square\s+(?:metres?|m)|sq\.?\s*(?:metres?|m)|(?:metres?|m)\s+squared|m\s*(?:2|squared))(?![a-z0-9])/gi, '$1m²')
      .replace(/(\d+(?:\.\d+)?)\s*m²?\s*²/gi, '$1m²')
      .replace(/(\d+(?:\.\d+)?)\s*(?:kilograms?|kgs?|k\s*g)\b/gi, '$1kg')
      .replace(/(\d+(?:\.\d+)?)\s*(?:grams?|grammes?|gm)\b/gi, '$1g')
      .replace(/(\d+(?:\.\d+)?)\s*(?:millilitres?|mls?)\b/gi, '$1ml')
      .replace(/(\d+(?:\.\d+)?)\s*(?:millimetres?|mils?)\b/gi, '$1mm')
      .replace(/(\d+(?:\.\d+)?)\s*(?:metres?)(?!\s*(?:squared|²))\b/gi, '$1m')
      .replace(/(\d+)\s+(m²|kg|g|ml|mm)(?![a-z])/gi, '$1$2');
  }

  // ---- product codes: "be 230", "bee two thirty", "a 200" -> B230, A200 --------------------------------------------------
  var LETTER_WORDS = { a: 'A', eh: 'A', ay: 'A', b: 'B', be: 'B', bee: 'B', c: 'C', see: 'C', sea: 'C', d: 'D', dee: 'D', e: 'E', f: 'F', eff: 'F', g: 'G', gee: 'G', jee: 'G', p: 'P', pee: 'P', s: 'S' };
  function codes(text) {
    var words = text.split(/\s+/), out = [], i = 0;
    while (i < words.length) {
      var lw = LETTER_WORDS[clean(words[i])];
      if (lw && words[i].indexOf('-') < 0) {
        var j = i + 1, run = [];
        while (j < words.length && (/^\d+$/.test(words[j]) || kind(words[j])) && run.length < 6) { run.push(words[j]); j++; }
        var after = (words[j] || '').toLowerCase();
        if (run.length && !/^(?:g|grams?|grammes?|kgs?|kilo|kilos|kilograms?|m|metres?|meters?|m²|mm|millimet|square|sq|ml|litres?|lt|lts|ltr|x)(?![a-z])/.test(after)) {
          var d = run.length === 1 && /^\d+$/.test(run[0]) ? run[0] : (run.every(function (x) { return /^\d+$/.test(x); }) ? run.join('') : digits(run));
          if (d && CODES.indexOf(lw + d) >= 0) { out.push(lw + d); i = j; continue; }
          // letter name + a shorter part of the run (e.g. "a 200 trim" with trailing words) is handled by the loop above
        }
      }
      out.push(words[i]); i++;
    }
    return out.join(' ');
  }

  // ---- phonetic fix against the catalogue vocabulary ------------------------------------------------------------
  function key(w) {
    var s = w.toLowerCase().replace(/[^a-z]/g, '');
    if (!s) return '';
    s = s.replace(/ph/g, 'f').replace(/ck|q/g, 'k').replace(/c(?=[eiy])/g, 's').replace(/c/g, 'k').replace(/z/g, 's').replace(/x/g, 'ks').replace(/wr/g, 'r').replace(/kn/g, 'n').replace(/(.)\1+/g, '$1');
    return s.charAt(0) + s.slice(1).replace(/[aeiouyhw]/g, '');
  }
  var VOCAB_KEYS = {};
  VOCAB.forEach(function (w) { if (w.length >= 4) { var k = key(w); if (!VOCAB_KEYS[k]) VOCAB_KEYS[k] = w; } });
  var VOCAB_SET = {};
  VOCAB.forEach(function (w) { VOCAB_SET[w] = 1; });
  var KEEP_SET = {};
  KEEP.forEach(function (w) { KEEP_SET[w] = 1; });

  function phonetic(text, changes) {
    return text.split(/\s+/).map(function (w) {
      var lw = w.toLowerCase();
      if (!/^[a-z]{4,}$/.test(lw) || VOCAB_SET[lw] || KEEP_SET[lw]) return w;
      var hit = VOCAB_KEYS[key(lw)];
      if (hit && hit !== lw && Math.abs(hit.length - lw.length) <= 2) { changes.push(w + ' -> ' + hit); return hit; }
      return w;
    }).join(' ');
  }

  // ---- merchant corrections (Theme settings > Search): "heard = correct", one per line ----------------------------------
  function parseExtra(str) {
    var rules = [];
    String(str || '').split(/\r?\n/).forEach(function (line) {
      var m = line.split('=');
      if (m.length < 2) return;
      var from = m.shift().trim(), to = m.join('=').trim();
      if (!from || !to) return;
      rules.push([new RegExp('(?:^|\\b)' + from.replace(/[.*+?^${}()|[\]\\]/g, '\\$&').replace(/\s+/g, '\\s+') + '(?:\\b|$)', 'gi'), to]);
    });
    return rules;
  }

  // "I'm looking for a ..." -> "..."
  var LEAD = /^(?:(?:hi|hello|hey|okay|ok)\s+)?(?:(?:can|could|may)\s+(?:i|you|we)\s+(?:please\s+)?(?:get|have|see|find|show|buy|order)\s+(?:me\s+)?|(?:i\s*(?:'|’)?\s*m|i\s+am)\s+looking\s+for\s+|i\s*(?:'|’)?\s*(?:d|ll)\s+like\s+|i\s+(?:need|want|would\s+like)\s+|looking\s+for\s+|do\s+you\s+(?:sell|have|stock)\s+|(?:show|find|get|search\s+for|search)\s+(?:me\s+)?|where\s+(?:can\s+i\s+)?(?:get|buy|find)\s+)(?:an?\s+|some\s+|the\s+|any\s+)?/i;
  var TRAIL = /\s+(?:please|thanks|thank\s+you|for\s+me)\.?$/i;

  function normalise(raw, extra) {
    var changes = [];
    var t = String(raw || '').replace(/[?!]+$/g, '').replace(/\.(?=\s|$)/g, '').replace(/\s+/g, ' ').trim();
    var before = t;
    t = t.replace(LEAD, '').replace(TRAIL, '');
    if (t !== before) changes.push('removed lead-in words');
    var steps = [];
    if (extra) steps.push(['your corrections', parseExtra(extra)]);
    steps.push(['built-in phrases', FRK_VOICE_PHRASES]);
    steps.forEach(function (st) {
      st[1].forEach(function (r) {
        var b = t;
        t = t.replace(r[0], r[1]);
        if (t !== b) changes.push(st[0] + ': ' + b + ' -> ' + t);
      });
    });
    t = t.replace(/\bfour[\s-]+fifty\b/gi, '450');   // "four fifty" (grams) is 450
    var n = codes(t); if (n !== t) { changes.push('product code: ' + t + ' -> ' + n); t = n; }
    n = numberWords(t); if (n !== t) { changes.push('numbers: ' + t + ' -> ' + n); t = n; }
    n = t.replace(/\bral\s+(\d{2})\s+(\d{2})\b/gi, 'RAL $1$2').replace(/\bral\s+(\d)\s+(\d)\s+(\d)\s+(\d)\b/gi, 'RAL $1$2$3$4').replace(/\b(?:rail|real|rowl|rawl|raul|r\s*a\s*l)(?=\s+\d{4}\b)/gi, 'RAL').replace(/\bral\b/gi, 'RAL');
    if (n !== t) { changes.push('RAL: ' + t + ' -> ' + n); t = n; }
    n = units(t); if (n !== t) { changes.push('units: ' + t + ' -> ' + n); t = n; }
    n = codes(t); if (n !== t) { changes.push('product code: ' + t + ' -> ' + n); t = n; }
    t = phonetic(t, changes);
    return { text: t.replace(/\s+/g, ' ').trim(), changes: changes };
  }

  // Pick the best of the recogniser's alternatives: the one that reads most like the shop's products.
  function score(text, confidence, index) {
    var s = (confidence || 0) * 3 - index * 0.25, hits = 0;
    text.toLowerCase().split(/\s+/).forEach(function (w) {
      if (VOCAB_SET[w]) { s += 2; hits++; }
      else if (/^\d+(?:\.\d+)?(?:m²|kg|g|ml|mm|m)$/.test(w)) { s += 3; hits++; }
      else if (CODES.indexOf(w.toUpperCase()) >= 0) { s += 4; hits++; }
      else if (/^ral$/.test(w)) s += 1;
      else if (/^\d{4}$/.test(w)) s += 1;
      else if (!KEEP_SET[w] && /^[a-z]{4,}$/.test(w)) s -= 0.5;   // an unfamiliar word
    });
    return { score: s, hits: hits };
  }
  function rank(alternatives, extra) {
    var seen = {}, cands = [];
    (alternatives || []).forEach(function (a, i) {
      var n = normalise(a.transcript, extra), k = n.text.toLowerCase();
      if (!n.text || seen[k] !== undefined) return;
      seen[k] = cands.length;
      var sc = score(n.text, a.confidence, i);
      cands.push({ text: n.text, raw: a.transcript, confidence: a.confidence, changes: n.changes, score: sc.score, hits: sc.hits });
    });
    var ordered = cands.slice().sort(function (a, b) { return b.score - a.score; });
    return { best: ordered[0] || null, others: ordered.slice(1, 4), all: cands };
  }

  // Phrases offered to the browser's recogniser as hints (used where the browser supports it)
  var HINTS = ['Cure It', 'Cure It One', 'RoofCell', 'Stronghold', 'Trade Grade', 'PRO GRP', 'Cromar', 'AceGrip', 'GRP', 'fibreglass', 'topcoat', 'resin', 'catalyst', 'hardener', 'MEKP', 'CSM', 'chopped strand mat', 'fascia trim', 'drip trim', 'flashing', 'RAL', 'roofing kit', 'heavy duty', 'balcony'];

  return { normalise: normalise, rank: rank, key: key, CODES: CODES, VOCAB: VOCAB, HINTS: HINTS, FRK_VOICE_PHRASES: FRK_VOICE_PHRASES };
});
